import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer } from 'components/';
import { Query, QueryResult } from 'react-apollo';
import * as Queries from 'api/graphql/queries';
import { adminBannerPlaces, OrderDirection } from '@api/graphql/types';
import { SortingRule } from 'react-table';
import ReduxTable from '@components/ReduxTable';

type Props = InjectedIntlProps & RouteComponentProps;

const BannerPlaceTypeCell = (row : any) => {
    if (row.value === 'SLIDER') {
        return <span>Slider</span>;
    }
    return <span>Banner</span>;
};

const BannerPlaceListDefaultOptions = {
    sortBy: {
        field: 'id',
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
    filters: {
        id: '',
        name: '',
        type_id: '',
    },
};

const listName = 'bannerPlaceList';

class BannerPlaceList extends React.Component<Props> {
    private defaultSorted: SortingRule[] = [
        {id: 'id', desc: true},
    ];

    private tableColumns = [
        this.getDefaultColumnByName('id'),
        this.getDefaultColumnByName('name'),
        this.getDefaultColumnByName('type_id', {Cell: BannerPlaceTypeCell}),
    ];

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: true,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.bannerPlace.${id}` });
    }

    private renderList(result: QueryResult<adminBannerPlaces>) {
        if (result.loading) return null;
        if (result.error) return `Error!: ${result.error}`;

        if (result.data) {
            return (
                <ReduxTable
                    filterable={false}
                    listName={listName}
                    defaultOptions={BannerPlaceListDefaultOptions}
                    data={result.data.adminBannerPlaces}
                    columns={this.tableColumns}
                    defaultPageSize={10}
                    defaultSorted={this.defaultSorted}
                    className="-striped -highlight"
                />
            );
        }
        return null;
    }

    public render() {
        return (
            <Drawer>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <Query query={Queries.adminBannerPlaces}>
                                    {queryResult => this.renderList(queryResult)}
                                </Query>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default compose(
    withRouter,
    injectIntl,
)(BannerPlaceList);



// WEBPACK FOOTER //
// ./src/modules/BannerPlace/pages/BannerPlaceList.tsx